<rt-input
  [value]="value"
  [displayedValue]="displayLocaleFormatting ? displayedValue : null"
  [placeholder]="placeholder"
  [disabled]="disabled"
  [readOnly]="readOnly"
  [invalid]="!!ngControl?.invalid"
  (blur)="blur.emit($event)"
  (valueChange)="handleChange($event)"
  (focus)="onFocus()"
/>
